import DOMPurify from "dompurify";
import cn from "classnames";
import { specialOfferApi } from "@rshbintech.dboul/http";
import commonStyles from "../../../styles.scss";
import { useMicroserviceAvailable } from "../../../../hooks";
import { MICROSERVICES_NAMES } from "../../../../common/constants";
import { SpecialOfferHeaderProps } from "./types";
import styles from "./styles.scss";

// TODO: Проработка плейсментов с типом "TAB" будет реализованна в следующем релизе спецпредложений
export const SpecialOfferTab = ({
  settings,
  dataTestId = "special-offer-tab",
  onClick,
}: SpecialOfferHeaderProps) => {
  const { text, background, textColor, imageName, imageId } = settings;

  const isSpecialOffersTemplatesMicroserviceAvailable =
    useMicroserviceAvailable(MICROSERVICES_NAMES.SPECIAL_OFFERS_TEMPLATES);

  return (
    <div
      className={styles["special-offer-tab"]}
      style={{ background: background }}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      <img
        alt={imageName}
        src={`${specialOfferApi.baseUrl}/api/special-offers/${
          isSpecialOffersTemplatesMicroserviceAvailable ? "v2" : "v1"
        }/external/special-offers/image/${imageId}`}
        className={styles["special-offer-tab-img"]}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(text ?? ""),
        }}
        className={cn(
          styles["special-offer-tab-text"],
          commonStyles["size-medium-long"]
        )}
        style={{ color: textColor }}
      />
    </div>
  );
};
